module.exports = "body {\t\n\tbackground: none transparent !important;\n\tfont-family: 'Lato','Crimson text', 'Dax', Helvetica, 'Rotis', Arial;\n\tbackground-size: auto;\n\tbackground-repeat: no-repeat;\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles